import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { IconProps, SvgIcon } from '../SvgIcon';

interface LogoProps extends IconProps {
  isDisabled?: boolean;
  variant?: 'default' | 'small';
}

const useStyles = makeStyles(() => ({
  default: {
    height: '29.14px',
    width: '84.65px',
  },

  small: {
    height: '21.86px',
    width: '63.49px',
  },

  disabled: {
    '& svg path': {
      filter: 'grayscale(100%) opacity(40%)',
    },
  },
}));

export function PayGreenPassRestaurant(props: LogoProps): JSX.Element {
  const classes = useStyles();
  const { isDisabled = false, variant = 'default', ...rest } = props;

  const iconStyle = clsx(
    classes.default,
    variant === 'small' && classes.small,
    isDisabled && classes.disabled,
  );

  return (
    <SvgIcon
      className={iconStyle}
      name="PayGreenPassRestaurant"
      viewBox="0 0 84.65 29.14"
      {...rest}
    >
      <path
        d="M64.9628 1.22875C63.1855 1.86177 62.4307 3.15214 62.4307 4.88075C62.4307 6.60937 63.1611 7.48585 65.0115 7.97278C68.5661 8.82491 68.5174 8.94665 68.5174 9.67705C68.5174 10.237 68.2983 10.4805 67.5192 10.724C65.7662 11.2109 62.5768 10.164 62.5768 10.164L62.4064 12.7934C65.328 13.4508 68.7608 13.1586 69.8564 12.8178C71.439 12.2821 72.3155 11.0648 72.3155 9.33619C72.3155 7.48585 71.3903 6.51198 69.0287 5.85462C66.1314 5.09987 65.9366 5.00249 65.8636 4.44251C65.7906 4.15035 65.9853 3.73646 66.2531 3.54169C66.8862 3.0791 68.2252 3.05475 69.5643 3.27387C70.5138 3.41995 71.3172 3.68777 71.3172 3.68777L71.6581 1.03398C71.6581 1.03398 70.319 0.81486 68.8826 0.74182C67.2027 0.644433 65.5958 1.00963 64.9628 1.22875Z"
        fill="#C6313B"
      />
      <path
        d="M76.4057 0.717558C74.3605 1.42361 73.6301 2.42182 73.6301 4.36956C73.6301 6.31729 74.4823 7.29116 76.6004 7.82679C80.6663 8.77631 80.642 8.89804 80.642 9.72583C80.642 10.3588 80.3742 10.6023 79.4977 10.8945C77.5012 11.4301 73.8249 10.2858 73.8249 10.2858L73.6301 13.2074C76.9656 13.9378 80.9098 13.6213 82.1758 13.2317C84.0018 12.6231 85 11.2597 85 9.33628C85 7.26681 83.9288 6.17121 81.2263 5.44081C77.9151 4.58868 77.6717 4.78345 77.5743 4.15044C77.4769 3.83393 77.696 3.347 78.0369 3.12788C78.7429 2.6166 80.3011 2.59225 81.835 2.83572C82.9062 3.00615 83.8557 3.2983 83.8557 3.2983L84.2209 0.328011C84.2209 0.328011 82.4193 0.133237 80.7637 0.133237C78.5969 0.108891 77.1604 0.474091 76.4057 0.717558Z"
        fill="#C6313B"
      />
      <path
        d="M59.2169 1.93489C58.1213 1.39926 55.4675 0.912331 52.8381 2.05662L53.0085 4.05305C53.0085 4.05305 53.9093 3.83393 54.6397 3.76089C56.7092 3.56612 57.5857 3.98001 57.5857 5.29473V5.97644H56.3927C52.7407 5.97644 51.7425 7.41289 51.7425 9.36063C51.7425 11.7466 53.0329 12.7692 55.9788 12.7692H60.9942V8.53284C61.0186 3.59047 60.7508 2.64095 59.2169 1.93489ZM57.61 10.8458C57.61 10.8458 56.904 10.8458 56.344 10.8458C55.2971 10.8458 54.1285 10.651 54.1285 9.38497C54.1285 8.24068 54.9806 7.94852 56.1005 7.94852C56.271 7.94852 57.61 7.94852 57.61 7.94852V10.8458Z"
        fill="#C6313B"
      />
      <path
        d="M45.1202 2.00795L43.4402 2.3488V12.2092H44.8524H45.9966V10.5049V8.80067H47.2627C50.0138 8.80067 51.426 7.55899 51.426 5.14867C51.4016 2.12968 49.5026 1.22885 45.1202 2.00795ZM47.6766 6.85293C47.1409 6.87728 45.9723 6.85293 45.9723 6.85293V3.93133C45.9723 3.93133 47.2383 3.93133 47.6766 3.93133C48.1392 3.93133 49.0887 4.27219 49.0887 5.39213C49.113 6.58512 48.1392 6.82859 47.6766 6.85293Z"
        fill="#C6313B"
      />
      <path
        d="M0.34668 20.8036V29.2762L2.41615 29.2032L4.60735 29.1058L4.63169 23.5547H5.89772L9.52537 28.6675H14.1025L10.0123 22.5809L10.9862 21.5827C13.2504 19.221 13.0556 16.2751 10.4749 14.0595C9.11148 12.8909 8.16196 12.3066 3.36567 12.3066H0.34668V20.8036ZM7.84545 16.2507C9.40364 18.1011 8.18631 20.7305 5.75164 20.7305H4.583V15.3012C4.583 15.3012 5.33775 15.2525 5.97076 15.3012C6.84724 15.3743 7.35852 15.6421 7.84545 16.2507Z"
        fill="#2F2977"
      />
      <path
        d="M15.3686 20.5601V28.3754L23.3056 28.205V25.4051H21.1631H19.0206V23.4087V21.4366L23.33 21.3636V18.6368L18.9962 18.5881V17.2003V15.8369L21.1874 15.8856L23.33 15.9343V14.5222V13.0857L15.3686 12.7205V20.5601Z"
        fill="#2F2977"
      />
      <path
        d="M27.4689 13.5482C26.0325 14.2543 25.3021 15.6664 25.3021 17.4437C25.3021 19.3914 26.0325 20.5114 28.2724 21.9235C30.147 23.0921 30.5609 23.8469 29.7818 24.6503C29.2706 25.1616 28.6376 25.0642 27.1524 24.2851C26.422 23.8955 25.7403 23.4817 25.7403 23.4817L25.3751 26.2572C25.3751 26.2572 25.9107 26.8171 26.495 27.158C27.2985 27.6936 28.175 27.9371 29.0028 27.9371C31.267 27.9371 33.166 26.1841 33.166 23.4817C33.166 21.5583 32.533 20.3653 30.4149 19.0749C28.6376 17.9793 28.1506 17.2976 28.7106 16.6159C29.1975 16.0316 30.0497 16.0803 31.1696 16.7863C31.7052 17.1272 32.0948 17.4437 32.0948 17.4437L33.02 15.0821C33.02 15.0821 31.0966 13.0613 29.441 13.0613C28.5402 13.0856 28.0045 13.2804 27.4689 13.5482Z"
        fill="#2F2977"
      />
      <path
        d="M34.0912 16.202H36.9154V27.2554H38.3275H39.7396V16.202H42.5638V13.6456L34.0668 13.4508V16.202H34.0912Z"
        fill="#2F2977"
      />
      <path
        d="M50.866 26.6954L50.7442 21.9235C50.6712 18.4906 50.5008 16.908 50.1843 16.202C49.1861 13.9864 47.1896 13.1343 45.4854 14.2056C43.7811 15.2525 43.4402 16.4941 43.4402 22.0695V26.9632H45.9966V22.7269H48.2609V26.6954H50.866ZM48.2122 20.414H45.7775V18.2228C45.7775 18.2228 45.8019 16.275 46.9949 16.275C48.1878 16.275 48.1878 18.2228 48.1878 18.2228V20.414H48.2122Z"
        fill="#2F2977"
      />
      <path
        d="M52.2294 18.0523C52.2294 22.4347 52.5703 24.4068 53.5442 25.5268C54.9319 27.2067 57.1231 26.7441 58.1944 24.6016C58.7056 23.5547 58.7543 22.8486 58.7543 18.8071V14.2056H56.8066L56.7092 18.7584C56.6605 22.5565 56.5388 23.3599 56.1492 23.7495C55.7597 24.139 55.5893 24.1634 55.2484 23.8712C54.8832 23.579 54.6154 22.7269 54.6154 18.8558V14.2299H52.2294V18.0523Z"
        fill="#2F2977"
      />
      <path
        d="M65.0114 21.4365C65.0114 21.4365 65.3766 21.0227 65.5713 20.7792C66.7887 19.2697 66.4722 16.5185 64.9383 15.2525C64.2079 14.6195 63.794 14.5221 62.2359 14.5221H60.4099V26.1355H62.4063V22.1669H63.088L64.8896 25.819H67.1295L65.0114 21.4365ZM63.2341 20.3166H62.4306V16.3481H63.2341C63.2341 16.3481 64.4027 16.762 64.4027 18.3445C64.4027 19.9514 63.2341 20.3166 63.2341 20.3166Z"
        fill="#2F2977"
      />
      <path
        d="M72.3885 16.275C71.585 14.5464 70.4407 14.1082 69.1747 14.9603C67.9817 15.8124 67.8113 16.9567 67.8113 21.5826V25.8433H69.5642V22.1426H71.2198V25.5511H72.9241V21.5096C72.9241 18.1497 72.8024 17.2733 72.3885 16.275ZM71.2198 20.1705H69.5642V18.3688C69.5642 18.3688 69.6616 16.7376 70.4407 16.7376C71.2198 16.7376 71.2198 18.3688 71.2198 18.3688V20.1705Z"
        fill="#2F2977"
      />
      <path
        d="M74.044 14.8386V25.2833H75.6022L75.6265 20.2679L78.0369 25.1129H78.8403V15.0821H77.4525V19.9758L75.164 14.8386H74.044Z"
        fill="#2F2977"
      />
      <path
        d="M79.3516 16.9081H80.8855V24.9912H81.6646H82.4437V16.9081H83.9775V15.2282L79.3516 15.1064V16.9081Z"
        fill="#2F2977"
      />
    </SvgIcon>
  );
}
